const initialLayersState = {}

const operative = (state = initialLayersState, action) => {
  switch (action.type) {
    case "ADD_LAYER":
      if (Object.keys(state).length > Object.keys(action.val).length) {
        const val = {}
        const preparedData = _.filter(action.val, (d) => {
          return _.some(state, (s) => s.id !== d.id)
        })
        preparedData.forEach((d) => {
          val[d.name] = { ...d, [d.name]: false, id: d.id }
        })
        return { ...val }
      } else {
        return { ...action.val }
      }

    // case "DELETE_LAYERS":
    //   const val = {}
    //   const preparedData = _.filter(state, (d) => d.id !== action.id)
    //   preparedData.forEach((d) => {
    //     val[d.category_name] = { ...d, [d.category_name]: false, id: d.id }
    //   })
    //   return { ...val }
    default:
      return state
  }
}

export default operative
